export default {"src":"/sitetest/_next/static/media/first_nav_active06.8dd9a48f.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};